import { DirectiveBinding } from "vue/types/options";
import { DirectiveOptions, VNode } from "vue/types/umd";
import { SearchInputInterface } from "@/types/searchInput";

const clearSearchInput: DirectiveOptions = {
  bind(_el: HTMLElement, _binding: DirectiveBinding, vnode: VNode) {
    const component = vnode.componentInstance as SearchInputInterface | null;
    if (!component) return;

    component.$watch("value", (inputValue: string | null) => {
      if (!inputValue) return;

      component.$nextTick(() => {
        component.internalSearch = "";
      });
    });

    component.$on("blur", () => {
      component.$nextTick(() => {
        component.internalSearch = "";
      });
    });
  },
};

export default clearSearchInput;
